import { useForm } from 'react-hook-form';
import { GENERAL_ENQUETE_JSON_INPUT_TYPE } from 'src/@types/generalEnquete';
import { RootState, useSelector } from 'src/redux/store/index';
import {
  QuestionCheckboxForm,
  QuestionCommentForm,
  QuestionDropdownForm,
  QuestionForm,
  QuestionRadioGroupForm,
  QuestionTextForm,
} from './common/components/shared';

const EnqueteCreateQuestionCompliaSwitcher = () => {
  const question = useSelector((state: RootState) => state.enqueteCreate.question);
  const methods = useForm({ mode: 'onChange' });

  const renderSwitch = (type: string) => {
    switch (type) {
      case GENERAL_ENQUETE_JSON_INPUT_TYPE.TEXT:
        return <QuestionTextForm methods={methods} />;
      case GENERAL_ENQUETE_JSON_INPUT_TYPE.TEXTAREA:
        return <QuestionCommentForm methods={methods} />;
      case GENERAL_ENQUETE_JSON_INPUT_TYPE.CHECKBOX:
        return <QuestionCheckboxForm methods={methods} />;
      case GENERAL_ENQUETE_JSON_INPUT_TYPE.RADIOGROUP:
        return <QuestionRadioGroupForm methods={methods} />;
      case GENERAL_ENQUETE_JSON_INPUT_TYPE.SELECT:
        return <QuestionDropdownForm methods={methods} />;
      default:
        return null;
    }
  };

  return question.inputType ? <QuestionForm methods={methods}>{renderSwitch(question.inputType)}</QuestionForm> : null;
};

export default EnqueteCreateQuestionCompliaSwitcher;
